import { connect, useSelector } from 'react-redux'
import { useState, useEffect } from 'react'
import { Tooltip, Popover, Button } from 'antd'
import { GraphFilterPanel } from 'Components'
import { useHotKeys } from 'Hooks'
import Feather from '@sysunite/react-feather'
import './GraphFilterButton.scss'
import { flatMapUnique } from 'Services/GraphFilterUtils'

GraphFilterButton = (props) ->
  { onChangeFilter } = props

  [ isOpen, setIsOpen ] = useState(false)
  [ isTooltipVisible, setTooltipVisible ] = useState(false)

  filterActive = useSelector(({ graphFilter }) ->
    flatMapUnique(graphFilter.filteredNodes).length > 0 or
    flatMapUnique(graphFilter.filteredRelations).length > 0
  )

  iconType = if isOpen then 'x' else 'eye'
  classNames = ['graph-filter']

  if isOpen
    classNames.push('is-open')

  useHotKeys([{
    sequence: 'esc'
    fn: ->
      setIsOpen(false)
    expr: isOpen
    temporary: true
    watchers: [isOpen]
  }, {
    sequence: 'i'
    fn: ->
      setIsOpen(true)
    watchers: []
  }])

  open = ->
    setIsOpen(!isOpen)
    setTooltipVisible(false)

  <Tooltip visible={not isOpen and isTooltipVisible}
       placement="bottomLeft"
       trigger="hover"
       onVisibleChange={(visible) ->
         if not isOpen
           setTooltipVisible(visible)
       }
       mouseEnterDelay={1}
       title="Filter relations or types in the graph.">
    <div
      onContextMenu={(e) -> e.stopPropagation()}
      className={classNames.join(' ')}>
      <Button
        type='link'
        onClick={open}
        icon={<Feather size="1.5em" type={iconType} />}
        className={filterActive && 'active' }
      />
      {
        if isOpen
          <GraphFilterPanel isVisible={isOpen}
                            onChangeFilter={onChangeFilter} />
      }
    </div>
  </Tooltip>

export default connect(
  ({ graphFilter: { filterActive }}) ->
    { filterActive }
)(GraphFilterButton)
